"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwodocGlobalControls = void 0;
class SwodocGlobalControls {
    static get globalControls() {
        return this._globalControls;
    }
}
exports.SwodocGlobalControls = SwodocGlobalControls;
SwodocGlobalControls._globalControls = [
    {
        _id: '1',
        name: 'Aktivitätsfaktor',
    },
    {
        _id: '2',
        name: 'Alter des Patienten',
        suffix: 'Jahre',
    },
    {
        _id: '3',
        name: 'andere Form Breite',
    },
    {
        _id: '4',
        name: 'andere Form Länge',
    },
    {
        _id: '5',
        name: 'Änderung Ernährungsvorschlag',
    },
    {
        _id: '6',
        name: 'Sonde Anlage',
    },
    {
        _id: '7',
        name: 'Anleitung und Schulung',
    },
    {
        _id: '8',
        name: 'Armstrong',
    },
    {
        _id: '9',
        name: 'Art Débridement Durchführung',
    },
    {
        _id: '10',
        name: 'Art der Inkontinenz',
    },
    {
        _id: '11',
        name: 'Art der Läsion',
    },
    {
        _id: '12',
        name: 'Art der medik. Therapie',
    },
    {
        _id: '13',
        name: 'Art diab. Fußsyndrom',
    },
    {
        _id: '14',
        name: 'Art Ulcus Cruris',
    },
    {
        _id: '15',
        name: 'artieriell / venös',
    },
    {
        _id: '16',
        name: 'Artikel',
    },
    {
        _id: '17',
        name: 'Begleiterkrankung',
    },
    {
        _id: '18',
        name: 'Bemusterung',
    },
    {
        _id: '19',
        name: 'Besonderheiten',
    },
    {
        _id: '20',
        name: 'Beurteilung der Ausscheidung',
    },
    {
        _id: '21',
        name: 'Beurteilung der Schleimhaut',
    },
    {
        _id: '22',
        name: 'Beurteilung der Stomanähte',
    },
    {
        _id: '23',
        name: 'bisherige Therapie',
    },
    {
        _id: '24',
        name: 'BMI',
    },
    {
        _id: '25',
        name: 'Breite',
    },
    {
        _id: '26',
        name: 'CH/Größe',
    },
    {
        _id: '27',
        name: 'Dauer Aufenthalt',
    },
    {
        _id: '28',
        name: 'Débridement seit',
    },
    {
        _id: '29',
        name: 'Derzeitige Basisplatte',
    },
    {
        _id: '30',
        name: 'Derzeitiges Beutelsystem',
    },
    {
        _id: '31',
        name: 'Derzeitiges Grundsystem',
    },
    {
        _id: '32',
        name: 'Diagnose',
    },
    {
        _id: '33',
        name: 'Dialysepflichtig',
    },
    {
        _id: '34',
        name: 'Diarrhoe',
    },
    {
        _id: '35',
        name: 'Durchmesser',
    },
    {
        _id: '36',
        name: 'Enterostoma Ausscheidung',
    },
    {
        _id: '37',
        name: 'Entstehungsort Wunde',
    },
    {
        _id: '38',
        name: 'erhöhter Eiweißbedarf',
    },
    {
        _id: '39',
        name: 'Exsudat Farbe',
    },
    {
        _id: '40',
        name: 'Exsudat Geruch',
    },
    {
        _id: '41',
        name: 'Exsudat Zustand',
    },
    {
        _id: '42',
        name: 'Fontaine',
    },
    {
        _id: '43',
        name: 'freie Flüssigkeit oral',
    },
    {
        _id: '44',
        name: 'freie Flüssigkeit über Sonde',
    },
    {
        _id: '45',
        name: 'Freiliegende Strukturen',
    },
    {
        _id: '46',
        name: 'Gesamt-Energiebedarf',
        icon: 'alberta-energydemand',
        suffix: 'Kcal/Tag',
    },
    {
        _id: '47',
        name: 'Gesamt-Flüssigkeitsbedarf',
        icon: 'alberta-fluiddemand',
        suffix: 'ml/Tag',
    },
    {
        _id: '48',
        name: 'Gewichtsverlauf',
    },
    {
        _id: '49',
        name: 'Grad der Verbrennung',
    },
    {
        _id: '50',
        name: 'Grunderkrankung',
    },
    {
        _id: '51',
        name: 'Haut/Schleimhäute',
    },
    {
        _id: '52',
        name: 'Hersteller',
    },
    {
        _id: '53',
        name: 'Infektion',
    },
    {
        _id: '54',
        name: 'Infektionskrankheit',
    },
    {
        _id: '55',
        name: 'Inkontinenz',
    },
    {
        _id: '56',
        name: 'Insulinpflichtig',
    },
    {
        _id: '57',
        name: 'Irrigation',
    },
    {
        _id: '58',
        name: 'Istgewicht',
        icon: 'alberta-targetweight',
        suffix: 'kg',
    },
    {
        _id: '59',
        name: 'Wechselintervall jeden (x) Tag',
    },
    {
        _id: '60',
        name: 'Juckreiz',
    },
    {
        _id: '61',
        name: 'Keimnachweis',
    },
    {
        _id: '62',
        name: 'Klassifizierung Dekubitus',
    },
    {
        _id: '63',
        name: 'Klinikaufenthalt',
    },
    {
        _id: '64',
        name: 'Kolo-/Ileostomie Art',
    },
    {
        _id: '65',
        name: 'Komplikationen',
    },
    {
        _id: '66',
        name: 'Komplikationen Aszites',
    },
    {
        _id: '67',
        name: 'Komplikationen Aszites detail',
    },
    {
        _id: '68',
        name: 'Komplikationen Diarrhoe',
    },
    {
        _id: '69',
        name: 'Komplikationen Diarrhoe detail',
    },
    {
        _id: '70',
        name: 'Komplikationen Dyspnoe',
    },
    {
        _id: '71',
        name: 'Komplikationen Dyspnoe detail',
    },
    {
        _id: '72',
        name: 'Komplikationen Erbrechen',
    },
    {
        _id: '73',
        name: 'Komplikationen Erbrechen detail',
    },
    {
        _id: '74',
        name: 'Komplikationen nahungsbedingt',
    },
    {
        _id: '75',
        name: 'Komplikationen nahungsbedingt detail',
    },
    {
        _id: '76',
        name: 'Komplikationen Obstipation',
    },
    {
        _id: '77',
        name: 'Komplikationen Obstipation detail',
    },
    {
        _id: '78',
        name: 'Komplikationen sonstiges',
    },
    {
        _id: '79',
        name: 'Komplikationen Übelkeit',
    },
    {
        _id: '80',
        name: 'Komplikationen Übelkeit detail',
    },
    {
        _id: '81',
        name: 'Körpergröße',
        suffix: 'cm',
    },
    {
        _id: '82',
        name: 'Krankenhausaufenthalt',
    },
    {
        _id: '83',
        name: 'Küchenkost oral',
    },
    {
        _id: '84',
        name: 'Lage Eiter',
    },
    {
        _id: '85',
        name: 'Lage Fibrin',
    },
    {
        _id: '86',
        name: 'Lage Nekrose feucht',
    },
    {
        _id: '87',
        name: 'Lage Nekrose trocken',
    },
    {
        _id: '88',
        name: 'Lage Wundrand',
    },
    {
        _id: '89',
        name: 'Stoma Länge',
    },
    {
        _id: '90',
        name: 'lokale Einflussfaktoren',
    },
    {
        _id: '91',
        name: 'Lokalisation Wunde',
    },
    {
        _id: '92',
        name: 'mehrere Wunden gleicher Art',
    },
    {
        _id: '93',
        name: 'Mobilitätseinschränkung',
    },
    {
        _id: '94',
        name: 'Niereninsuffizienz',
    },
    {
        _id: '95',
        name: 'orale Aufnahme Flüssigkeit',
    },
    {
        _id: '96',
        name: 'orale Aufnahme Nahrung',
    },
    {
        _id: '97',
        name: 'Orale Stimmulation',
    },
    {
        _id: '98',
        name: 'Pat.Nr./PZN',
    },
    {
        _id: '99',
        name: 'Patientensituation',
    },
    {
        _id: '100',
        name: 'Pflegegrad',
    },
    {
        _id: '101',
        name: 'Reiter',
    },
    {
        _id: '102',
        name: 'Reiter entfernt am',
    },
    {
        _id: '103',
        name: 'rezidiv?',
    },
    {
        _id: '104',
        name: 'rund/Durchmesser',
    },
    {
        _id: '105',
        name: 'S.A.C.S.',
    },
    {
        _id: '106',
        name: 'Schleimhaut',
    },
    {
        _id: '107',
        name: 'Schluckfähigkeit',
    },
    {
        _id: '108',
        name: 'Sollgewicht',
        icon: 'alberta-targetweight',
        suffix: 'kg',
    },
    {
        _id: '109',
        name: 'Sonde Lage',
    },
    {
        _id: '110',
        name: 'Sonde seit',
    },
    {
        _id: '111',
        name: 'Sondeneintrittsstelle',
    },
    {
        _id: '112',
        name: 'Sondennahrung Energie',
    },
    {
        _id: '113',
        name: 'Sondennahrung Flüssigkeit',
    },
    {
        _id: '114',
        name: 'sonstige Flüssigkeit',
    },
    {
        _id: '115',
        name: 'sonstiger Belag',
    },
    {
        _id: '116',
        name: 'Stomaart',
    },
    {
        _id: '117',
        name: 'Stomaform und -größe',
    },
    {
        _id: '118',
        name: 'Stomalage',
    },
    {
        _id: '119',
        name: 'Stomaversorgung',
    },
    {
        _id: '120',
        name: 'Symptome',
    },
    {
        _id: '121',
        name: 'systemische Einflussfaktoren',
    },
    {
        _id: '122',
        name: 'Tasche 1 cm',
    },
    {
        _id: '123',
        name: 'Tasche 1 Lage',
    },
    {
        _id: '124',
        name: 'Tasche 2 cm',
    },
    {
        _id: '125',
        name: 'Tasche 2 Lage',
    },
    {
        _id: '126',
        name: 'Tasche 3 cm',
    },
    {
        _id: '127',
        name: 'Tasche 3 Lage',
    },
    {
        _id: '128',
        name: 'Tasche 4 cm',
    },
    {
        _id: '129',
        name: 'Tasche 4 Lage',
    },
    {
        _id: '130',
        name: 'Taschen-Tiefe',
    },
    {
        _id: '131',
        name: 'Taschen vorhanden',
    },
    {
        _id: '132',
        name: 'Topographie der Läsion',
    },
    {
        _id: '133',
        name: 'Traumafaktor',
    },
    {
        _id: '134',
        name: 'Trinknahrung Energie',
    },
    {
        _id: '135',
        name: 'Trinknahrung Flüssigkeit',
    },
    {
        _id: '136',
        name: 'Urostoma Ausscheidung',
    },
    {
        _id: '137',
        name: 'Urostomie Art',
    },
    {
        _id: '138',
        name: 'Ursache Juckreiz',
    },
    {
        _id: '139',
        name: 'Veränderung Allgemeinzustand',
    },
    {
        _id: '140',
        name: 'Versorgungssituation d. Patienten',
    },
    {
        _id: '141',
        name: 'Wagner',
    },
    {
        _id: '142',
        name: 'Wechselintervall Basisplatte',
    },
    {
        _id: '143',
        name: 'Wechselintervall Beutelsystem',
    },
    {
        _id: '144',
        name: 'Widmer',
    },
    {
        _id: '145',
        name: 'Wiegedatum',
    },
    {
        _id: '146',
        name: 'Wunde vorhanden seit',
    },
    {
        _id: '147',
        name: 'Wunde-Nr.',
    },
    {
        _id: '148',
        name: 'Wundgröße Breite',
    },
    {
        _id: '149',
        name: 'Wundgröße Länge',
    },
    {
        _id: '150',
        name: 'Wundgröße Tiefe',
    },
    {
        _id: '151',
        name: 'Wundgrund Farbe',
    },
    {
        _id: '152',
        name: 'Wundgrund Belag',
    },
    {
        _id: '153',
        name: 'Wundgrund Farbe',
    },
    {
        _id: '154',
        name: 'Wundheilungsphase',
    },
    {
        _id: '155',
        name: 'Wundheilungstendenz',
    },
    {
        _id: '156',
        name: 'Wundinfektion',
    },
    {
        _id: '157',
        name: 'Wundrand',
    },
    {
        _id: '158',
        name: 'Wundschmerzen permanent',
    },
    {
        _id: '159',
        name: 'Wundschmerzen unter Belastung',
    },
    {
        _id: '160',
        name: 'Wundschmerzen Verbandswechsel',
    },
    {
        _id: '161',
        name: 'Wundumgebung',
    },
    {
        _id: '162',
        name: 'Wundursache',
    },
    {
        _id: '163',
        name: 'Wundversorgung',
    },
    {
        _id: '164',
        name: 'Zielgewicht',
    },
    {
        _id: '165',
        name: 'Vorname',
    },
    {
        _id: '166',
        name: 'Nachname',
    },
    {
        _id: '167',
        name: 'Kundennummer',
    },
    {
        _id: '168',
        name: 'Geburtstag',
    },
    {
        _id: '169',
        name: 'Ort',
    },
    {
        _id: '170',
        name: 'Erstellt von',
    },
    {
        _id: '171',
        name: 'Erstellt am',
    },
    {
        _id: '172',
        name: 'Unterschrift',
    },
    {
        _id: '173',
        name: 'Küchenkost',
        suffix: 'kcal/Tag',
    },
    {
        _id: '174',
        name: 'Geschlecht',
    },
    {
        _id: '175',
        name: 'Amputation1',
    },
    {
        _id: '176',
        name: 'Amputation2',
    },
    {
        _id: '177',
        name: 'Rezeptabholung',
    },
    {
        _id: '178',
        name: 'Fotodokumentation',
    },
];
